import React from 'react';
import './LibraryItemCard.scss';

const LibraryItemCard = ({ innerRef, children, ...props }) => {
  return (
    <div
      className="library-item-card2"
      data-testid="library-item-card"
      {...props}
      ref={innerRef}
    >
      <div className="draggedLibraryItemCard">{children}</div>
    </div>
  );
};
export default LibraryItemCard;
